(function () {
  'use strict';

  function initTabs(container) {
    if (container._tabsInitialized) return;
    container._tabsInitialized = true;

    const tabs = container.querySelectorAll('[data-collection-tab]');
    const panels = container.querySelectorAll('[data-collection-panel]');

    // The View All button is rendered by the _product-list-button block inside the
    // static header. Find the first link within that container — that's the View All.
    const staticHeader = container.querySelector('.collection-tabs__static-header');
    const viewAll = staticHeader ? staticHeader.querySelector('a[href]') : null;

    if (!tabs.length || !panels.length) return;

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        const targetIndex = tab.dataset.tabIndex;

        // Update tab states
        tabs.forEach(function (t) {
          const isActive = t === tab;
          t.classList.toggle('is-active', isActive);
          t.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        // Update panel visibility
        panels.forEach(function (p) {
          const isActive = p.dataset.tabIndex === targetIndex;
          p.classList.toggle('is-active', isActive);
          if (isActive) {
            p.removeAttribute('hidden');
          } else {
            p.setAttribute('hidden', '');
          }
        });

        // Update the View All link's href to point to the active collection
        if (viewAll && tab.dataset.collectionUrl) {
          viewAll.href = tab.dataset.collectionUrl;
        }
      });
    });
  }

  function initAll(root) {
    const scope = root || document;
    scope.querySelectorAll('[data-collection-tabs]').forEach(initTabs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  // Re-init when sections load in the theme editor
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
